import { FaAward, FaCode, FaUsers } from 'react-icons/fa';

const data = [
    {
        id: 1,
        icon: <FaCode />,
        title: 'Engineer',
        desc: 'Passionate about developing cutting-edge software solutions'
    },
    {
        id: 2,
        icon: <FaUsers />,
        title: 'Team Player',
        desc: 'Experienced in working with dynamic software development teams'
    },
    {
        id: 3,
        icon: <FaAward />,
        title: 'Experience',
        desc: '3+ years of experience delivering high-quality, reliable solutions'
    }
];

export default data;